import(/* webpackMode: "eager" */ "/app/src/app/(main-app)/about/page.tsx");
